const postAreasStr = {
  toastrSuccess: 'Departamento adicionado',
  toastrSuccess1: ' foi adicionado com sucesso',
  toastrError: 'Departamento já cadastrado', 
  toastrError2: 'Insira outro nome'
};

export default postAreasStr;
